import { createSlice } from '@reduxjs/toolkit';
import { format } from 'date-fns';
import { RecruitInfo } from '../../models/recruitInfo.model';

export const initialState: RecruitInfo = {
	user_email: '',
	recruit_id: '',
	general_details: {
		current_company: '',
		first_contacted_date: format(new Date(), 'MM/dd/yyyy'),
		last_contacted_date: format(new Date(), 'MM/dd/yyyy'),
		city: '',
		state_id: null,
		name: '',
		phone: '',
		recruiting_manager_id: null,
		role_id: null,
		stage_id: null,
		email: '',
		is_producing: false,
		nmls_id: '',
	},
	outside_recruiter_details: {
		is_outside_recruiter: false,
		name: '',
		payment_type_id: null,
		bps: '0',
		bps_months: '0',
		flat_fee: '$0',
		other_method: '',
	},
	production_details: {
		monthly_units: '',
		monthly_volume: '',
		conventional_loans: '0',
		bonds: '0',
		government_loans: '0',
		broker: '0',
		jumbo: '0',
	},
	staff_details: {
		staff_total: '0',
		staff_lo: '0',
		staff_closers: '0',
		staff_loa: '0',
		staff_underwriters: '0',
		staff_office_id: null,
		staff_processors: '0',
		staff_others: '0',
	},
};

const recruitFormReducerSlice = createSlice({
	name: 'recruitFormReducer',
	initialState,
	reducers: {
		setRecruitForm(
			state,
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			action: { payload: RecruitInfo; type: any },
		) {
			return { ...action.payload };
		},
	},
});

export const { setRecruitForm } = recruitFormReducerSlice.actions;
export default recruitFormReducerSlice.reducer;
